<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('accountStracture') }}</v-toolbar-title>
      <v-btn
        v-if="isMobile || isTablet"
        outlined
        color="teal"
        class="mx-3 mt-4"
        x-small
        @click="newGroup"
      >
        {{ $t('newGroup') }}
      </v-btn>
      <v-spacer />
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            link
            @click="openUploadDialog"
          >
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="getItems"
          >
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="(isMobile || isTablet) && id"
            link
            @click="goTo(type)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important;padding: 0 !important;"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && id && !isTablet"
        outlined
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-row>
              <v-col class="pe-0">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  clearable
                  :label="$t('search')"
                  flat
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <div
                class="ms-3 mt-2 tree-coding"
              >
                <v-treeview
                  :items="items"
                  selected-color="primary"
                  item-key="id"
                  open-on-click
                  dense
                  :search="search"
                  :filter="filter"
                  :open="filteredKeys"
                  expand-icon="mdi-chevron-down"
                >
                  <template v-slot:label="{ item }">
                    <v-hover v-slot:default="{ hover }">
                      <v-list-item
                        dense
                        class="px-1"
                      >
                        <!--                  <v-list-item-icon-->
                        <!--                    v-if="hover"-->
                        <!--                    class="me-2"-->
                        <!--                  >-->
                        <!--                  </v-list-item-icon>-->
                        <v-list-item-content class="d-inline">
                          <v-list-item-title
                            class="d-inline"
                          >
                            <div v-if="item.level == 'group'">
                              {{ item.number }} - {{ item.name }}
                            </div>
                            <div v-if="item.level == 'total'">
                              {{ item.group.number +''+ item.number }} - {{ item.name }}
                            </div>
                            <div v-if="item.level == 'given'">
                              {{ item.total.group.number +''+ item.total.number+''+ item.number }} - {{ item.name }}
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="d-inline my-0 px-1">
                          <v-btn
                            v-if="hover"
                            small
                            class="float-end mt-1"
                            icon
                            @click.stop.prevent="openDeleteDialog(item)"
                          >
                            <v-icon color="pink">
                              mdi-delete-outline
                            </v-icon>
                          </v-btn>
                          <v-btn
                            v-if="hover"
                            icon
                            class="float-end mt-1"
                            small
                            @click.stop.prevent="(item.level == 'group' ? editGroup(item) : (item.level === 'total' ? editTotal(item) : editGiven(item)))"
                          >
                            <v-icon color="grey">
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <v-btn
                            v-if="hover && item.level != 'given'"
                            outlined
                            color="teal"
                            x-small
                            class="mt-2 mx-2"
                            @click.stop.prevent="(item.level === 'group' ? newTotal(item) : newGiven(item))"
                          >
                            {{ (item.level == 'group' ? $t('newTotal') : $t('newGiven')) }}
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-hover>
                  </template>
                </v-treeview>
              </div>
            </v-row>
          </v-col>
          <v-col
            v-if="!isMobile"
          >
            <div
              v-if="groupCard"
              class="coding"
            >
              <div class="d-flex">
                <v-subheader style="height: 29px">
                  {{ (groupItem ? $t('editGroup') : $t('newGroup')) }}
                </v-subheader>
                <v-spacer />
                <v-btn
                  v-if="groupItem"
                  outlined
                  color="teal"
                  class="mx-3 mt-1"
                  x-small
                  @click="newGroup"
                >
                  {{ $t('newGroup') }}
                </v-btn>
              </div>
              <v-divider
                class="mb-0"
              />
              <group
                :item="groupItem"
                :hide-close="true"
                @close="closeDialog"
              />
            </div>
            <div
              v-if="totalCard"
              class="coding"
            >
              <div class="d-flex">
                <v-subheader style="height: 29px">
                  {{ (totalItem ? $t('editTotal') : $t('newTotal')) }}
                </v-subheader>
                <v-spacer />
              </div>
              <v-divider
                class="mb-0"
              />
              <total
                :group-prop="groupProp"
                :item="totalItem"
                @close="closeDialog"
              />
            </div>
            <div
              v-if="givenCard"
              class="coding"
            >
              <div class="d-flex">
                <v-subheader style="height: 29px">
                  {{ (givenItem ? $t('editGiven') : $t('newGiven')) }}
                </v-subheader>
                <v-spacer />
              </div>
              <v-divider
                class="mb-0"
              />
              <given
                :total-prop="totalProp"
                :item="givenItem"
                :get-object="true"
                @return="givenReturn"
                @close="closeDialog"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          />
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$router.go(-1)"
            >
              {{ $t('back') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <!--    group dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="groupDialog"
      width="100%"
      max-width="450px"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="groupDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('group') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <group
            :item="groupItem"
            @close="closeDialog"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    total dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="totalDialog"
      width="100%"
      max-width="450px"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="totalDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('total') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <total
            :group-prop="groupProp"
            :item="totalItem"
            @close="closeDialog"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    given dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="givenDialog"
      width="100%"
      max-width="450px"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="givenDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('given') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <given
            :total-prop="totalProp"
            :item="givenItem"
            @close="closeDialog"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    delete dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="accountStructure"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import Snakbar from '../../components/general/snakbar/snakbar'
  import General from '../../../../Mixins/general'
  import Group from './group'
  import Total from './total'
  import Given from './given'
  import Upload from '../../components/general/upload/upload'
  export default {
    name: 'Coding',
    components: {
      Snakbar,
      Group,
      Upload,
      Total,
      Given,
    },
    mixins: [General],
    props: ['returnObject'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      uploadDialog: false,
      render: false,
      groupCard: true,
      totalCard: false,
      givenCard: false,
      isLoading: false,
      alert: false,
      permissions: [],
      id: null,
      open: [],
      deletDialog: false,
      tag: null,
      search: null,
      valid: null,
      message: null,
      alertType: null,
      items: null,
      name: null,
      type: null,
      role: null,
      status: 'active',
      groupDialog: false,
      totalDialog: false,
      givenDialog: false,
      groupItem: null,
      groupProp: null,
      totalProp: null,
      totalItem: null,
      givenItem: null,
      caseSensitive: false,
      openAll: false,
      loading: false,
    }),
    computed: {
      filteredKeys () {
        if (this.search) {
          return this.items.map((top) => {
            return top.id
          })
        } else {
          return []
        }
      },
      // openAll () {
      //   return true
      //   // if (this.search) {
      //   //   return true
      //   // } else {
      //   //   return false
      //   // }
      // },
      filter () {
        var filter = this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined
        return filter
      },
    },
    watch: {
      search (val) {
      },
    },
    beforeMount () {
    },
    mounted () {
      this.getItems()
    },
    methods: {
      openUploadDialog (item) {
        if (this.$root) {
          this.$root.$emit('open-user-file-process', { type: 'accountStructure' })
        }
      },
      newGroup () {
        this.groupItem = null
        if (this.isMobile) {
          this.groupDialog = true
        } else {
          this.groupCard = true
          this.totalCard = false
          this.givenCard = false
        }
      },
      newTotal (item) {
        this.groupProp = item
        this.totalItem = null
        if (this.isMobile) {
          this.totalDialog = true
        } else {
          this.groupCard = false
          this.totalCard = true
          this.givenCard = false
        }
      },
      newGiven (item) {
        this.totalProp = item
        this.givenItem = null
        if (this.isMobile) {
          this.givenDialog = true
        } else {
          this.groupCard = false
          this.totalCard = false
          this.givenCard = true
        }
      },
      editGroup (item) {
        this.groupItem = item
        if (this.isMobile) {
          this.groupDialog = true
        } else {
          this.groupCard = true
          this.totalCard = false
          this.givenCard = false
        }
      },
      editTotal (item) {
        this.groupProp = item.group
        this.totalItem = item
        if (this.isMobile) {
          this.totalDialog = true
        } else {
          this.groupCard = false
          this.totalCard = true
          this.givenCard = false
        }
      },
      editGiven (item) {
        this.totalProp = item.total
        this.givenItem = item
        if (this.isMobile) {
          this.givenDialog = true
        } else {
          this.groupCard = false
          this.totalCard = false
          this.givenCard = true
        }
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'coding/' + this.deleteItem.id, {
          params: {
            level: app.deleteItem.level,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.deletDialog = false
            app.deleteItem = null
          })
      },
      closeDialog () {
        this.getItems()
        this.groupDialog = false
        this.totalDialog = false
        this.givenDialog = false
        this.newGroup()
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'coding', {
          params: {
            search: app.search,
            page: app.options.page,
            type: app.type,
            sortBy: app.sortBy,
            options: app.options,
          },
        })
          .then(res => {
            res = res.data
            app.items = res
            app.$nextTick(() => {
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'coding/0/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      givenReturn (item) {
        this.$emit('input', item)
      },
    },
  }
</script>

<style scoped>
.tree-coding {
  height: 400px;
  overflow-y: scroll;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #e3e3e3;
}
.coding {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #e3e3e3;
}
</style>
